<template>
    <el-form :model="form" :rules="rules" ref="form" v-if="show" class="invoice-void-form" label-position="top">
        <div id="invoice-detail-void-anchor"></div>
        <div class="detail-row footer">
            <div class="detail-block">
                <h3>撤銷發票申請</h3>
                <el-form-item prop="foO_CNL_DAT" label="撤銷日期">
                    <el-date-picker v-model="form.foO_CNL_DAT" value-format="timestamp" type="date" placeholder="請選擇"> </el-date-picker>
                </el-form-item>
                <el-form-item prop="foO_CNL_MEM" label="撤銷原因">
                    <el-input v-model.trim="form.foO_CNL_MEM" :rows="3" type="textarea" maxlength="200" show-word-limit placeholder="說明撤銷原因（必填）"></el-input>
                </el-form-item>
            </div>
            <div class="warnings-block">
                <div class="title">注意！撤銷後將會產生以下作用：</div>
                <ul>
                    <li>營業收入將不會計算此單。</li>
                    <li v-if="isIncomeExist">出入帳紀錄將不會計算此單。</li>
                    <li v-if="isProjectExist">此單上的專案分期將恢復為未開發票。</li>
                    <li v-if="invoice.typ !== 1 && isInvoiceVoid">[作廢]{{ invoice.foo }} 仍會列入營業稅申報</li>
                    <li v-else-if="invoice.foo && invoice.typ !== 1 && invoice.typ !== 4">該發票號碼 <ahReceiptNumber :v="invoice.foo" /> 將不列入營業稅申報</li>
                    <el-checkbox style="margin-left: -20px; margin-top: 30px" size="mini" v-model="confirmRevoke">
                        我瞭解了，確定撤銷
                    </el-checkbox>
                </ul>
            </div>
            <div style="text-align: right">
                <el-button type="" @click="handleCancel">取消</el-button>
                <el-button type="primary" class="primary-action" :loading="isSubmitting" :disabled="isRevokeDisabled" @click="onSubmit">
                    <span>確認</span>
                    <span>撤銷</span>
                </el-button>
            </div>
        </div>
    </el-form>
</template>
<script>
import ahReceiptNumber from '@/components/ui/ahReceiptNumber.vue';

export default {
    name: 'invoice-void',
    components: { ahReceiptNumber },
    props: ['show', 'sno', 'invoice'],
    computed: {
        isIncomeExist() {
            return this.invoice.incomes?.length;
        },
        isProjectExist() {
            return this.invoice.projects?.length;
        },
        isInvoiceVoid() {
            return this.invoice.foO_DIS_CNL;
        },
        isRevokeDisabled() {
            return !this.confirmRevoke;
        },
    },
    data() {
        return {
            isSubmitting: false,
            form: {
                foO_CNL_DAT: Date.now(),
                foO_CNL_MEM: null,
            },
            rules: {
                foO_CNL_MEM: [
                    {
                        required: true,
                        message: '請填寫撤銷原因（必填）',
                        trigger: 'blur',
                    },
                ],
                foO_CNL_DAT: [
                    {
                        required: true,
                        message: '請選擇日期',
                        trigger: 'blur',
                    },
                ],
            },
            confirmRevoke: false,
        };
    },
    watch: {
        invoice(newVal) {
            this.confirmRevoke = false;
            if (newVal.foO_DIS_MEM) this.form.foO_CNL_MEM = newVal.foO_DIS_MEM;
        },
        show(val) {
            if (!val) this.form.foO_CNL_MEM = null;
        },
    },
    methods: {
        handleCancel() {
            this.$emit('canceled');
            this.confirmRevoke = false;
        },
        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        this.onDeleteInvoice();
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        },
        async onDeleteInvoice() {
            try {
                this.isSubmitting = true;
                await this.$confirm('確認要撤銷此發票？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                await this.$api({
                    url: '/InvoiceManagemnetPage/VoidInvoice',
                    method: 'POST',
                    data: { sno: this.sno, ...this.form },
                });

                this.$message({
                    showClose: true,
                    message: '發票已撤銷。',
                    type: 'success',
                });
                this.$emit('submitted');
            } finally {
                this.isSubmitting = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.invoice-void-form {
    .warnings-block {
        margin: 0 0 15px 0;
        background-color: #fffdf7;
        padding: 20px 30px;
        border: 1px solid #e6a23c;
        border-radius: 5px;

        > .title {
            font-weight: bold;
            margin-bottom: 8px;
            color: #e6a23c;
        }

        ul {
            margin: 0 0 0 20px;
        }
    }
}
</style>
